import {
  defaultTransformRequest,
  defaultTransformResponse,
  RequestConfig,
} from '~/common/services/requests';
import { TransformerSet } from '../../../constants';
import { REQUEST_TRANSFORMER_SET_MAP } from '../../../constants/requestTransformerSetMap';
import { RESPONSE_TRANSFORMER_SET_MAP } from '../../../constants/responseTransformerSetMap';

export const addTransformersToConfig = (
  config: RequestConfig,
  transformerSet: TransformerSet,
): RequestConfig => ({
  ...config,
  transformRequest: [
    ...REQUEST_TRANSFORMER_SET_MAP[transformerSet],
    ...defaultTransformRequest,
  ],
  transformResponse: [
    ...defaultTransformResponse,
    ...RESPONSE_TRANSFORMER_SET_MAP[transformerSet],
  ],
});
